<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-august-1978-swanage-dorset">
<h1 style="margin-top:250px;">Part 1 <br/>August 1978<br/> Swanage, Dorset</h1>
<div class="section level2" id="saturday">
<h2>
</h2>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?6f3864e0